import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "task-detail-page" }

import { onMounted, PropType, provide, ref } from 'vue';
import { TaskDetail, TaskDetailTabEnum } from '@/components';
import { useRoute } from 'vue-router';
import { ProjectQueueTaskListItem } from '@/components/tasks-kanban/adapter';

// #region defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'task-detail-page',
  props: {
  /**информация очереди */
  queueInfo: {
    type: Array as PropType<ProjectQueueTaskListItem[]>,
  },
  /**ID задачи */
  taskId: {
    type: Number,
  },
  /**ID очереди */
  queueId: {
    type: String,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
  /**Активный таб */
  tab: {
    type: Number as PropType<TaskDetailTabEnum>,
    default: () => TaskDetailTabEnum.Actions,
  },
},
  emits: ["checkIsUserAccessTask"],
  setup(__props, { emit }) {


// #endregion defineProps


provide('popover-scroll-selector', '.project-list-wrapper-content');
provide('parent-scroll-container', '.project-list-wrapper-content');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TaskDetail), {
      "task-id": __props.taskId,
      "project-id": __props.projectId,
      "queue-id": __props.queueId,
      "namespace-id": __props.namespaceId,
      tab: __props.tab,
      queueInfo: __props.queueInfo,
      onCheckIsUserAccessTask: _cache[0] || (_cache[0] = ($event: any) => (emit('checkIsUserAccessTask', $event)))
    }, null, 8, ["task-id", "project-id", "queue-id", "namespace-id", "tab", "queueInfo"])
  ]))
}
}

})